import { createIndex } from 'react-instantsearch-core';
var Index = createIndex({
  Root: 'div',
  props: {
    className: 'ais-MultiIndex__root'
  }
});
export default Index;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch-dom/dist/es/widgets/Index.js
// module id = 987
// module chunks = 0 1 2 3 4 5 6 7 8